import { getId } from '../../Utils.js'

export default class User {

  constructor( api, idOrObj, opts ) {
    if ( opts && opts.noChild ) {
      this.api = api
    } else {
      this.api = api.child( `user/${getId( idOrObj )}` )
    }
    if ( opts == null || opts.allowMetadata !== false ) {
      this.update = update.bind( this )
      this.setMetadata = setMetadata.bind( this )
      this.updateMetadata = updateMetadata.bind( this )
    }
  }

  get( opts ) {
    return this.api.get( opts )
  }

  roles( opts ) {
    return this.api.child( 'role' ).get( opts )
  }

  // update( update ) {
  //   return this.api.patchRaw( update )
  // }

  delete( ) {
    return this.api.delete( )
  }

  addRole( role, opts ) { 
    let isOnePrimitive = false
    if ( typeof role === 'string' || typeof role === 'number' ) {
      role = [ role ]
      isOnePrimitive = true
    }
    return this.api.child( 'role' ).post( role, opts )
      .then( ( r ) => {
        return isOnePrimitive ? r[0] || null : r
      } )
  }

  addRoles( roles, opts ) {
    if ( !Array.isArray( roles ) ) {
      return this.addRole( roles )
    }
    return this.api.child( 'role' ).post( roles, opts ) 
  }

  removeRole( role, opts ) { 
    if ( typeof role === 'string' || typeof role === 'number' ) {
      role = [ role ]
    }
    return this.api.child( 'role' ).delete( role, opts )
  }

  removeRoles( roles, opts ) {
    if ( !Array.isArray( roles ) ) {
      return this.removeRole( roles )
    }
    return this.api.child( 'role' ).delete( roles, opts ) 
  }

  removeAllRoles( opts ) {
    return this.api.child( 'role' ).delete( { ...opts, removeAllRoles : true } ) 
  }

}

/**
 * Updates the user's data
 * @param {Object} data contains a key metadata which can be null, and object
 * or an array. If its null or an object, the metadata will be set. If it is an
 * array, it is treated as a patch ops
 */
function update( data, opts ) {
  return this.api.patchRaw( data, opts )
}

/**
 * Sets (replaces) the metadata of the user. This is equivalent to update( { metadata } )
 * @param {Object|null} metadata 
 * @returns promise
 */
function setMetadata( metadata, opts ) {
  if ( Array.isArray( metadata ) || typeof metadata !== 'object' ) {
    throw new Error( 'setMetadata expects null or an object. ' )
  }
  return this.api.patchRaw( { metadata }, opts )
} 

/**
 * Updates the metadata of the user using the supplied patchOps array. This is 
 * equivalent to update( { metadata : patchOps } )
 * @param {Array} patchOps and array of { path, value } objects
 * @returns promise
 */
function updateMetadata( patchOps, opts ) {
  if ( !Array.isArray( patchOps ) ) {
    throw new Error( 'updateMetadata expects an Array. ' )
  }
  return this.api.patchRaw( { metadata : patchOps }, opts )
}
